export default "__VITE_ASSET__H9La6FzO__"